const Archiveds = () => {
  return (
    <></>
  )
}

export default Archiveds
